import type {
  Correction,
  DeniedCorrection,
  Revision,
  Status,
} from "@/queries/formality-request";
import type { UserProfile } from "@/queries/me";
import type {
  FormalityRequestType,
  FormDetailResponse,
  FORM_ASSIGNMENTS_STATUS,
} from "@/types/entities/formality-request";
import { createContext } from "react";

export interface CorrectionFormContextType {
  rejectComments: string;
  setRejectComments: (value: string) => void;
  // selected revision and group from URL query params
  selectedRevisionId: string;
  setRevisionId: (value: string) => void;
  selectedGroupId: string | null;
  setGroupId: (value: string | null) => void;
  // state for corrections being made in the current cycle
  needsCorrectionCount: number;
  setNeedsCorrectionCount: (value: number) => void;
  corrections: Map<string, { status: "DENIED" | "APPROVED"; reason?: string }>;
  setCorrections: React.Dispatch<
    React.SetStateAction<
      Map<string, { status: "DENIED" | "APPROVED"; reason?: string }>
    >
  >;
  // Set de IDs de campos que fueron aprobados en ciclos anteriores y no pueden ser denegados
  lockedApprovedFields: Set<string>;
  setLockedApprovedFields: (value: Set<string>) => void;
  nonPreventableFields: Set<string>;
  setNonPreventableFields: (value: Set<string>) => void;

  // calculated values based on selected revision and group
  selectedRevision: Revision | null;
  revisionId: string;
  groupCorrectionInCurrentCycle: Correction | null;
  isReadOnlyView: boolean;
  isUserLeaderOfSelectedGroup: boolean;
  groupsCount: number;
  isLatestRevision: boolean;
  // fetched data
  formalityRequest: FormalityRequestType | undefined;
  form: FormDetailResponse | undefined;
  userProfile: UserProfile | undefined;
  revisions: Array<{
    groups: {
      id: string;
      name: string;
      description?: string | null;
    }[];
    corrections: Correction[];
    id: string;
    status: Status;
    requires_leader_approval: boolean;
    applicant_form_assignment_id?: string | null;
    applicant_form_assignment?: {
      id: string;
      status: keyof typeof FORM_ASSIGNMENTS_STATUS;
      applicant?: {
        id: string;
        first_name?: string;
        last_name?: string;
        email?: string;
        document_number?: string;
      };
    } | null;
    created_by?: string | null;
    created_at: string | null;
    updated_at: string | null;
    denied_corrections?: DeniedCorrection[];
  }>;
}

export const CorrectionFormContext = createContext<
  CorrectionFormContextType | undefined
>(undefined);
